import PropTypes from 'prop-types';
import Button from 'components/ui-components/Button';

const RegisterCtaCardTemplate = ({
  title,
  paragraph,
  body,
  button,
  underButton,
}) => (
  <>
    <div>
      {title && (
        <h2 className="ff-body fw-700 fs-26 s-fs-30 m-fs-32 lh-1 tc-main mb-10">
          {title}
        </h2>
      )}

      {paragraph && (
        <p className="fs-16 fw-400 tc-secondary mb-10">{paragraph}</p>
      )}

      {body && body}
    </div>

    {(button || underButton) && (
      <div className="fl fl-col ta-c mt-20">
        <Button
          type="button"
          className="cef-btn cef-btn--feature cef-btn--green"
          handleClick={button.handleClick}>
          {button.text}
        </Button>

        {underButton && underButton}
      </div>
    )}
  </>
);

RegisterCtaCardTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  paragraph: PropTypes.string.isRequired,
  body: PropTypes.node,
  button: PropTypes.shape({
    text: PropTypes.string,
    handleClick: PropTypes.func,
  }).isRequired,
  underButton: PropTypes.node,
};

export default RegisterCtaCardTemplate;
